export const MAIN_DEALERS_GROUP = [
  { id: 11, name: 'Chery' },
  { id: 905, name: 'Exeed' },
  { id: 994, name: 'JAECOO' },
  { id: 729, name: 'OMODA' },
];
